import * as styles from './index.css'

export const Loader = (props: {
  mode?: 'global' | 'local'
  state: boolean
  className?: string
}) => {
  return null
  // const mode = props.mode || 'local'

  // if (!props.state) {
  //   return null
  // }

  // return (
  //   <div className={styles.loaderVariant[mode]}>
  //     <video
  //       autoPlay
  //       loop
  //       muted
  //       className={styles.video}
  //     >
  //       <source
  //         src='/loader.webm'
  //         type='video/webm'
  //       />
  //     </video>
  //   </div>
  // )
}
